import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { attachNode, removeNode } from "../../../store/list-slice";
import FrameDialogContent from "../../../ui/containers/FrameDialogContent";

import FramePanelContent from "../../../ui/containers/FramePanelContent";
import Section from "../../../ui/containers/Section";
import ListEntryButton from "../../list-entry/ListEntryButton";
import CharacterRegiment from "./CharacterRegiment";
import NewCharacterButton from "./NewCharacterButton";
import NewRegimentButton from "./NewRegimentButton";
import Regiment from "./Regiment";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState, useContext } from "react";
import { createNode } from "../../../lib/list";
import FrameDialog from "../../../ui/containers/FrameDialog";
import FrameHeader from "../../../ui/containers/FrameHeader";
import EntryList from "../../entry/EntryList";
import FloatingActions from "../../../ui/FloatingActions";
import { useDispatch } from "react-redux";
import HorPanelsCtx from "../../../ui/layouts/HorPanelsCtx";
import ThePerfectToolButton from "./ThePerfectToolButton";
import BestOfTheRajakurButton from "./BestOfTheRajakurButton";

function sortingFn(a, b) {
	return a.toLowerCase()
		.localeCompare(b.toLowerCase());
}


function ListPanelContent({ faction, parsedList }) {
	const [nodeToSwap, setNodeToSwap] = useState(null);
	const open = !!nodeToSwap;
	const { onPanelRemove } = useContext(HorPanelsCtx);

	const types = faction.entryGroups.reduce((prev, cur) => {
		prev[cur.slug] = {
			min: cur.min ?? 0,
			max: cur.max ?? 9999,
		};
		return prev;
	}, {});

	const { children, points } = parsedList;
	const empty = children.length === 0;

	const characters = children.filter(c => c.type === "warlords");
	const filter = characters.map(e => e.entrySlug);
	if (points <= 500) filter.push("jotnar-seidr");
	const heroes = children.filter(c => c.type === "heroes");
	const mainstay = children.filter(c => c.type === "mainstay");
	const restricted = children.filter(c => c.type === "restricted");
	const monsters = children.filter(c => c.type === "monsters");
	const dispatch = useDispatch();

	const characterEntries = characters.map(c => <CharacterRegiment key={c.id} node={c} factionSlug={faction.slug} noDuplicate />);
	const heroEntries = heroes.map(r => <Regiment key={r.id} node={r} factionSlug={faction.slug} noDuplicate />);
	const mainstayEntries = mainstay.map(r => <Regiment key={r.id} node={r} factionSlug={faction.slug} noDuplicate />);
	const restrictedEntries = restricted.map(r => <Regiment key={r.id} node={r} factionSlug={faction.slug} noDuplicate />);
	const monsterEntries = monsters.map(r => <Regiment key={r.id} node={r} factionSlug={faction.slug} noDuplicate />);

	const promotedSlugs = [];
	let countMonsterWarlords = 0;
	characters.forEach(c => {
		const retinueOptions = c.listEntry.options?.groups?.find(g => g.slug === "retinue");
		if (retinueOptions) {
			promotedSlugs.push(...retinueOptions.orphans.filter(o => o.selected).map(s => s.slug));
		} else {
			promotedSlugs.push(...(c.listEntry.retinue?.map(r => r.slug) || []))
		}

		const tagGroups = c.listEntry.tagGroups || c.listEntry.profiles?.[0]?.tagGroups || [];
		const rolesTags = tagGroups.find(g => g.slug === "battlefield-roles")?.tags;
		const rolesSlugs = rolesTags?.map(r => r.slug) || [];

		if (rolesSlugs.includes("monster")) {
			countMonsterWarlords++;
		}
	});

	return (
		<FramePanelContent>
			<Stack spacing={5}>
				{!empty && (
					<Section title="Warlords" darkBgr>
						<Stack spacing={3}>
							{characterEntries}
						</Stack>
					</Section>
				)}
				{(characters.length < types["warlords"].max) && <NewCharacterButton faction={faction} listEmpty={empty} filter={filter} />}
				{!empty && (
					<Section title="Heroes" darkBgr>
						<Stack spacing={3}>
							{heroEntries}
							{heroes.length < types["heroes"].max && <NewRegimentButton faction={faction} type="heroes" filter={heroes.map(e => e.entrySlug)} />}
						</Stack>
					</Section>
				)}
				{!empty && (
					<Section title="Mainstay" darkBgr>
						<Stack spacing={3}>
							{mainstayEntries}
							{mainstay.length < types["mainstay"].max && <NewRegimentButton faction={faction} type="mainstay" promoted={promotedSlugs} filter={mainstay.map(e => e.entrySlug)} />}
						</Stack>
					</Section>
				)}
				{!empty && (
					<Section title="Restricted" darkBgr>
						<Stack spacing={3}>
							{restrictedEntries}
							{restricted.length < types["restricted"].max && <NewRegimentButton faction={faction} type="restricted" promoted={promotedSlugs} filter={restricted.map(e => e.entrySlug)} />}
						</Stack>
					</Section>
				)}
				{!empty && types["monsters"] && (
					<Section title="Monsters" darkBgr>
						<Stack spacing={3}>
							{monsterEntries}
							{monsters.length + countMonsterWarlords < types["monsters"].max && <NewRegimentButton faction={faction} type="monsters" filter={monsters.map(e => e.entrySlug)} />}
						</Stack>
					</Section>
				)}
			</Stack>
		</FramePanelContent>
	);
}


export default ListPanelContent;